// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooling-container {
  display: flex;
  gap: 20px;
  padding: 70px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.tooling-image {
  position: relative;
  width: 34%;
  order: 2;
  padding: 10px 0;
  margin-top: 50px;
  margin-left: 30px;
}

.tooling-text {
  width: 60%;
  margin-top: -20px;
}

.tooling-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 20px;
}

.tooling-text h2 {
  font-size: 1.5em !important;
  margin-top: 20px;
  color: #333;
}

.tooling-text p {
  font-size: 0.905rem;
  color: #555;
  line-height: 1.6;
}

.services-list {
  list-style: none;
  padding: 0;
  margin: 10px 0;
}

.services-list li {
  font-size: 1rem;
  color: #555;
  margin-bottom: 10px;
}

.services-list li strong {
  color: #333;
}

@media (max-width: 768px) {
  .tooling-container {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }

  .tooling-image {
    width: 140%;
    margin-left: -50px;
    margin-top: 70px;
    order: 1;
  }

  .tooling-text {
    width: 140%;
    margin-left: -40px;
    order: 2;
  }
}

@media (min-width: 1920px) and (max-width: 1920px) {
  .tooling-container {
    padding: 80px;
  }

  .tooling-image {
    width: 30%;
  }

  .tooling-text {
    width: 62%;
  }

  .services-list li {
    width: 40%;
  }
}

@media (min-width: 1380px) and (max-width: 1919px) {
  .tooling-container {
    padding: 90px;
  }

  .tooling-image {
    width: 29%;
  }

  .tooling-text {
    width: 63%;
  }

  .services-list li {
    width: 44%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Tooling/Tooling.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".tooling-container {\n  display: flex;\n  gap: 20px;\n  padding: 70px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.tooling-image {\n  position: relative;\n  width: 34%;\n  order: 2;\n  padding: 10px 0;\n  margin-top: 50px;\n  margin-left: 30px;\n}\n\n.tooling-text {\n  width: 60%;\n  margin-top: -20px;\n}\n\n.tooling-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 20px;\n}\n\n.tooling-text h2 {\n  font-size: 1.5em !important;\n  margin-top: 20px;\n  color: #333;\n}\n\n.tooling-text p {\n  font-size: 0.905rem;\n  color: #555;\n  line-height: 1.6;\n}\n\n.services-list {\n  list-style: none;\n  padding: 0;\n  margin: 10px 0;\n}\n\n.services-list li {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 10px;\n}\n\n.services-list li strong {\n  color: #333;\n}\n\n@media (max-width: 768px) {\n  .tooling-container {\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n  }\n\n  .tooling-image {\n    width: 140%;\n    margin-left: -50px;\n    margin-top: 70px;\n    order: 1;\n  }\n\n  .tooling-text {\n    width: 140%;\n    margin-left: -40px;\n    order: 2;\n  }\n}\n\n@media (min-width: 1920px) and (max-width: 1920px) {\n  .tooling-container {\n    padding: 80px;\n  }\n\n  .tooling-image {\n    width: 30%;\n  }\n\n  .tooling-text {\n    width: 62%;\n  }\n\n  .services-list li {\n    width: 40%;\n  }\n}\n\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .tooling-container {\n    padding: 90px;\n  }\n\n  .tooling-image {\n    width: 29%;\n  }\n\n  .tooling-text {\n    width: 63%;\n  }\n\n  .services-list li {\n    width: 44%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
